<template>
    <div>
      <slot>
        <div class="row row-spacing mb-2">
          <div class="col-md-auto">
            <button v-if="userEditRight" type="button" class="btn btn-info" @click="createNewPackage()">
             Add New Package
            </button>
          </div>
        </div>
      </slot>
      <div
        class="table-responsive table-bordered"
        v-if="packages.length > 0"
      >
        <table class="table">
            <thead>
            <tr class="text-nowrap">
                <th>Description</th>
                <th>Type</th>
                <th>Unit Cost (excl. VAT)</th>
                <th>Expired</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="resourcePackage in packages"
                :key="resourcePackage.virtualResourcePackageNumber"
            >
                <td> 
                  <input disabled type="text" class="form-control" v-model="resourcePackage.description"/>
                </td>
                <td>
                  <input disabled type="text" class="form-control" v-model="resourcePackage.type"/>
                </td>
                <td>
                {{
                    getPrice(resourcePackage.virtualresourcepackageprices, period)
                }}
                <span
                    v-if="userEditRight"
                    style="cursor: pointer"
                    @click="openPriceModal(resourcePackage)"
                    v-tooltip="'Edit Row Price'"
                    class="pull-right"
                >
                    <em class="fa fa-edit fa-fw text-green"></em>
                </span> 
                </td>
                <td class="text-center">
                  <span class="badge" :class="resourcePackage.expired ? 'badge-warning' : 'badge-green'">
                    {{ resourcePackage.expired }}
                  </span>
                </td>
                <td class="text-center">
                  <button v-if="userEditRight" v-tooltip="'Edit Package'" @click="editPackage(resourcePackage)" type="button" class="btn btn-sm btn-info m-1">
                    <em class="fa fa-edit fa-fw"></em>
                  </button>
                  <button v-if="userEditRight" v-tooltip="'Delete Row'" type="button" @click="deletePackage(resourcePackage)"
                    class="btn btn-sm btn-primary">
                    <em class="fa fa-trash fa-fw"></em>
                  </button>
                </td>
            </tr>
            </tbody>
        </table>
      </div>
      <div v-else class="alert alert-info">No Prices Available to Display</div>
      
      <VirtualResourceModifyPackage
        ref="packageModal"
        :types="resourceTypes"
        :pricePackage="newPricePackage"
        @packageAdded="packageAdded"
        @packageEdited="getPackages()"
      />       
      <AddResourcePriceModal
        ref="addPriceModal"
        :row-price="rowPrice"
        :new-price="newPrice"
        @addPrice="addPrice"
        @pricesAdded="$emit('get-resource-packages')"
        />
    </div>
  </template>
  
  <script>
  import PriceFunctions from "@/components/Admin/PriceFunctions";
  import VirtualResourceModifyPackage from "@/components/Admin/Modals/VirtualResourceModifyPackage";
  import AddResourcePriceModal from "@/components/Admin/VirtualServerPackages/AddResourcePriceModal";
  export default {
    extends: PriceFunctions,
    props: {
        userEditRight: {
          type: Boolean,
          required: true
        },
        packages: {
          type: Array,
          required: true,
        },
        emptyResourcePackage: {
          type: Object,
          required: true,
        },
        productNumber: {
          type: Number,
          required: true,
        }
    },
    components: {
      VirtualResourceModifyPackage,
      AddResourcePriceModal
    },
    data() {
      return {
        newPricePackage: {},
        rowPrice: [],
        newPrice: {},
        period: this.getCurrentPeriod(),
        resourceTypes: ["CPU","RAM","STORAGE","IP"]
      };
    },
    mounted() {
      this.getResourceTypes();
    },
    methods: {
      getPackages() {
        this.$emit("get-resource-packages");
      },
      packageAdded(resourcePackage) {
        resourcePackage.virtualresourcepackageprices = [];
        this.packages.push(resourcePackage);
        this.openPriceModal(resourcePackage);
      },
      getResourceTypes() {
        this.$http.get(this.$config.aimsAPI + "pricing/virtual/resourcepackages/types")
          .then((response) => {
            this.resourceTypes = response.data
          },(error) => {
            console.error(error);
            this.showError("Error Fetching Resource Types", error);
          }
        );
      },
      createNewPackage() {
        this.$http.get(this.$config.aimsAPI + "pricing/new/package/VirtualResourcePackage")
        .then(
          (response) => {
            this.newPricePackage = response.data;
            this.newPricePackage.productNumber = this.productNumber;
            this.$refs.packageModal.open();
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching Package template", error);
          }
        );
      },
      setNewPrice(resourcePackage) {
        this.$http.get(this.$config.aimsAPI + "pricing/new/price/VirtualResourcePackagePrice")
          .then((response) => {
              this.newPrice = response.data;
              this.newPrice.virtualResourcePackageNumber = resourcePackage.virtualResourcePackageNumber;
            },
            (error) => {
              console.error(error);
              this.showError("Error Fetching Package Price Template", error);
            }
          );
      },
      editPackage(sPackage) {
        this.newPricePackage = this.deepCopyObject(sPackage);
        this.$refs.packageModal.open();
      },
      openPriceModal(resourcePackage) {
        this.setNewPrice(resourcePackage);
        this.rowPrice = this.deepCopyObject(resourcePackage.virtualresourcepackageprices || []);
        this.$refs.addPriceModal.open();
      },
      addPrice(newPrice) {
        this.rowPrice.forEach((price) => {
            if (price.validUntil == 0) {
              if (newPrice.validFrom % 100 > 1) {
                  price.validUntil = newPrice.validFrom - 1;
              } else {
                  price.validUntil = newPrice.validFrom - 100 + 11;
              }
            }
        });
        this.rowPrice.push(newPrice);
        this.setNewPrice(newPrice);
      },
      deletePackage(resourcePackage) {
        this.$swal({
            title: "Are you sure you want to delete this price package?",
            type: "warning",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.value) {
            this.$http
                .delete(
                this.$config.aimsAPI +
                    "pricing/pricepackages/" +
                    resourcePackage.objKey +
                    "?objClassName=" +
                    resourcePackage.class
                )
                .then(
                (response) => {
                    this.showSuccess(response.data.message);
                    this.$emit("get-resource-packages");
                },
                (error) => {
                    this.showError("Error Deleting Price Package", error);
                }
                );
            }
        });
      }
    },
  };
  </script>
  